var metaMixin = {

  metaInfo () {
    if (!this.site || !this.site.settings || !this.page || !this.page) { return {} }

    return {
      title: (this.page.content.seo_title || this.page.content.title),
      description: this.page.content.seo_description,
      titleTemplate: '%s — ' + this.site.settings.site_name
    }
  }
}
export default metaMixin
